import {PC, Mobile} from "../../../../hooks/util/useMediaquery";

import LoginMobile from "./Mobile/Login";
import LoginPC     from "./PC/share";

const Login:React.FC<any> = () => {
  return (
    <>
      <PC>
        <LoginPC />
      </PC>

      <Mobile>
        <LoginMobile />
      </Mobile>
    </>
  );
};

export default Login;
